// extracted by mini-css-extract-plugin
module.exports = {"modulelist":"course-modules_modulelist__Tg4PD","into":"course-modules_into__QoEii","modules":"course-modules_modules__HnYcN","degreeCredits":"course-modules_degreeCredits__NW4fU"};